import { useRef } from 'react'

import { SwiperRefType } from '../swiper/Swiper'

import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import Image, { ImageProps } from '../image'

// style
import Swiper from '../swiper'
import styles from './productImageGallerySlider.module.scss'

export interface ProductImageGallerySliderProps {
  heading: string
  productImages: ImageProps[]
}

export const ProductImageGallerySlider = (props: ProductImageGallerySliderProps) => {
  const deviceInfo = useDeviceInfo()
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP

  const carouselRef: SwiperRefType = useRef(null)

  return (
    <div className={styles.gallaryWrap}>
      <div className={styles.galleryInner}>
        {props.heading && <h4 className={styles.heading}>{props.heading}</h4>}
        <Swiper
          showDots
          showNavigator={isDesktop}
          numberOfVisibleSlides={1}
          variableWidth={isDesktop}
          ref={carouselRef}
        >
          {props.productImages.map((item: ImageProps) => {
            return <Image {...item} alt={item.alt} key={item.url} className={styles.slideItem} />
          })}
        </Swiper>
      </div>
    </div>
  )
}

export default ProductImageGallerySlider
